/*Copyright (c) 2026. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc.
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

type NamedItem = {
  name: string;
};

export const sortByName = <T extends NamedItem>(
  items: T[] = []
): T[] => {
  return [...items].sort((a, b) => a.name.localeCompare(b.name));
};

export default sortByName;